<template>
    <div class="empty-state">
        <div class="image-container">
            <SvgLoader :path="`assets/img/empty-state/empty-${type}`" />
        </div>
        <div class="message-container">
            <div class="title copy-l">{{ message.title }}</div>
            <div class="description copy-m">{{ message.description }}</div>
        </div>
        <div class="action-container">
            <slot class="action-container" />
        </div>
    </div>
</template>

<script>
import SvgLoader from '@/components/SvgLoader'
export default {
    name: 'EmptyState',
    components: {
        SvgLoader,
    },
    props: {
        type: {
            type: String,
        },
        message: {
            type: Object,
            default() {
                return { title: 'Something', description: 'more stuff' }
            },
        },
    },
    computed: {
        image() {
            return 'venues'
        },
    },
}
</script>

<style scoped lang="sass">
.empty-state
    margin: 0 auto
    max-width: 500px
    text-align: center

    .title
        color: $neutral-4
        margin-bottom: $s

    .description
        color: $neutral-2

    .action-container
        display: flex
        align-items: center
        justify-content: center
        margin-top: $xl

        .button + .button
            margin-left: $m
</style>
